let preloaded = false

export async function preloadPosRoute(): Promise<void> {
 if (preloaded) return
 preloaded = true
 try {
 await import('../Routes/pos')
 } catch {
 preloaded = false
 }
 try {
 await import('../pages/POS/POSScreen')
 } catch {
 preloaded = false
 }
}

export function hasPosPermission(): boolean {
 try {
 const raw = localStorage.getItem('authUser')
 if (!raw) return false
 const parsed = JSON.parse(raw)
 const user = parsed?.user ?? parsed
 if (!user) return false
 if (user.is_super_admin) return true
 if (Array.isArray(user.roles)) {
 const superAdminRoles = ['Super Admin', 'owner']
 if (user.roles.some((r: string) => superAdminRoles.includes(r))) return true
 }
 if (Array.isArray(user.permissions)) {
 return user.permissions.includes('process_sales')
 }
 return false
 } catch {
 return false
 }
}

export function preloadPosIfPermitted(): void {
 if (hasPosPermission()) {
 void preloadPosRoute()
 }
}
